import React from "react";
import {
  Card,
  CardContent,
  CardActionArea,
  Typography,
  Box,
} from "@mui/material";
import PersonAddIcon from "@mui/icons-material/PersonAdd";

const DEFAULT_ADD_USER_CARD_CONFIG = {
  contentPadding: 3,
  height: 220,
  iconPadding: 2,
  iconSize: 40,
  subtitleVariant: "body2",
  titleVariant: "h6",
};

const AddUserCard = ({ displayConfig = DEFAULT_ADD_USER_CARD_CONFIG, onClick }) => {
  return (
    <Card
      sx={{
        height: displayConfig.height,
        borderRadius: 2,
        background: "linear-gradient(135deg, #603F97 0%, #D31D83 100%)",
        transition: "all 0.3s ease-in-out",
        position: "relative",
        overflow: "hidden",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 12px 30px rgba(96, 63, 151, 0.2)",
          "& .add-icon": {
            transform: "scale(1.1) rotate(5deg)"
          },
          "& .add-text": {
            transform: "translateY(-2px)"
          }
        },
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)",
          zIndex: 1
        }
      }}
      onClick={onClick}
    >
      <CardActionArea
        sx={{ height: "100%", position: "relative", zIndex: 2 }}
      >
        <CardContent
          sx={{
            height: "100%",
            p: displayConfig.contentPadding,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "white"
          }}
        >
          <Box
            className='add-icon'
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.15)",
              borderRadius: "50%",
              p: displayConfig.iconPadding,
              mb: 1.25,
              transition: "all 0.3s ease-in-out",
              backdropFilter: "blur(4px)"
            }}
          >
            <PersonAddIcon sx={{ fontSize: displayConfig.iconSize }} />
          </Box>
          <Typography
            className='add-text'
            variant={displayConfig.titleVariant}
            sx={{
              fontWeight: 600,
              lineHeight: 1.25,
              textAlign: "center",
              transition: "all 0.3s ease-in-out"
            }}
          >
            Add New User
          </Typography>
          <Typography
            variant={displayConfig.subtitleVariant}
            sx={{ lineHeight: 1.25, mt: 0.5, opacity: 0.9, textAlign: "center" }}
          >
            Invite a team member
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default AddUserCard;
